import { IRootState } from '..'

export const getLanding = (state: IRootState, id: string) =>
  state.landingState.landings.find(landing => landing.id === id)
